import React, { useState } from "react";

import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const WheelOfDivision = () => {
  const [angle, setAngle] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [options, setOptions] = useState([]);
  const [result, setResult] = useState("");
  const [prize, setPrize] = useState("");
  const [score, setScore] = useState(0);

  const questions = [
    { q: "240 ÷ 12", a: 20 },
    { q: "468 ÷ 13", a: 36 },
    { q: "816 ÷ 24", a: 34 },
    { q: "525 ÷ 15", a: 35 },
    { q: "396 ÷ 11", a: 36 },
    { q: "324 ÷ 12", a: 27 },
    { q: "728 ÷ 14", a: 52 },
    { q: "960 ÷ 16", a: 60 },
    { q: "672 ÷ 14", a: 48 },
    { q: "880 ÷ 20", a: 44 },
    { q: "715 ÷ 13", a: 55 },
    { q: "810 ÷ 18", a: 45 },
    { q: "999 ÷ 27", a: 37 },
    { q: "660 ÷ 15", a: 44 },
    { q: "850 ÷ 25", a: 34 },
    { q: "864 ÷ 12", a: 72 },
    { q: "945 ÷ 21", a: 45 },
    { q: "720 ÷ 18", a: 40 },
  ];

  const prizes = ["🎈 Balloon", "🧸 Teddy Bear", "🎁 Gift Box", "🎯 Dart Toy", "🎠 Toy Horse"];

  const spinWheel = () => {
    const newAngle = angle + Math.floor(Math.random() * 360 + 720);
    setAngle(newAngle);
    setTimeout(startChallenge, 2000);
  };

  const startChallenge = () => {
    const randomIndex = Math.floor(Math.random() * questions.length);
    const question = questions[randomIndex];
    setCurrentQuestion(question);
    setResult("");
    setPrize("");

    const opts = generateOptions(question.a);
    setOptions(opts);
  };

  const generateOptions = (correct) => {
    const opts = new Set([correct]);
    while (opts.size < 4) {
      const distractor = correct + Math.floor(Math.random() * 10 - 5);
      if (distractor > 0 && distractor !== correct) {
        opts.add(distractor);
      }
    }
    return shuffleArray([...opts]);
  };

  const shuffleArray = (arr) => {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  const checkAnswer = (selected) => {
    if (selected === currentQuestion.a) {
      setScore(score + 1);
      setResult("✅ Correct! You won a prize!");
      setPrize(prizes[Math.floor(Math.random() * prizes.length)]);
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setResult("❌ Oops! That's not correct.");
    }
  };

  return (
    <div style={styles.body}>
      <h1 style={styles.h1}>🧠 Wheel of Division</h1>
      <p style={{ fontSize: "18px" }}>Spin the wheel and solve division puzzles!</p>

      <div style={styles.wheelContainer}>
        <div style={styles.pointer}></div>
        <div
          style={{
            ...styles.wheel,
            transform: `rotate(${angle}deg)`,
          }}
        >
          Spin Me
        </div>
      </div>

      <button style={styles.button} onClick={spinWheel}>
        🎡 Spin the Wheel
      </button>

      <div style={styles.challenge}>{currentQuestion && `🧩 Solve: ${currentQuestion.q}`}</div>

      {options.length > 0 && (
        <div style={styles.optionsArea}>
          {options.map((opt, idx) => (
            <button
              key={idx}
              style={styles.optionBtn}
              onClick={() => checkAnswer(opt)}
            >
              {opt}
            </button>
          ))}
        </div>
      )}

      <div style={{ ...styles.result, color: result.includes("Correct") ? "green" : "red" }}>
        {result}
      </div>

      <div style={styles.prize}>{prize}</div>
      <div style={styles.score}>Score: {score}</div>
    </div>
  );
};

const styles = {
  body: {
    fontFamily: "'Segoe UI', sans-serif",
    background: "linear-gradient(135deg, #e0f7fa, #a7ffeb)",
    textAlign: "center",
    padding: "40px 20px",
    margin: 0,
    overflowX: "hidden",
    minHeight: "100vh",
    boxSizing: "border-box",
  },
  h1: {
    fontSize: "40px",
    marginBottom: "10px",
    color: "#00796b",
  },
  wheelContainer: {
    position: "relative",
    margin: "30px auto",
    width: "min(50vw, 250px)",
    height: "min(50vw, 250px)",
  },
  wheel: {
    width: "100%",
    height: "100%",
    border: "12px solid #00838f",
    borderRadius: "50%",
    background: "radial-gradient(#ffffff, #b2ebf2)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "26px",
    fontWeight: "bold",
    boxShadow: "0 0 20px rgba(0,0,0,0.3)",
    transition: "transform 2s ease-out",
  },
  pointer: {
    position: "absolute",
    top: "-20px",
    left: "50%",
    transform: "translateX(-50%)",
    width: 0,
    height: 0,
    borderLeft: "15px solid transparent",
    borderRight: "15px solid transparent",
    borderBottom: "25px solid #006064",
  },
  button: {
    padding: "12px 24px",
    fontSize: "18px",
    backgroundColor: "#00bcd4",
    color: "white",
    border: "none",
    borderRadius: "30px",
    boxShadow: "0 4px 10px rgba(0, 150, 136, 0.3)",
    transition: "background-color 0.3s ease",
    cursor: "pointer",
    marginTop: "20px",
  },
  challenge: {
    fontSize: "24px",
    marginTop: "25px",
    color: "#004d40",
  },
  optionsArea: {
    marginTop: "25px",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "15px",
  },
  optionBtn: {
    padding: "15px 25px",
    fontSize: "20px",
    color: "#004d40",
    background: "linear-gradient(145deg, #ffffff, #d0f0f0)",
    border: "2px solid #00acc1",
    borderRadius: "16px",
    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.15)",
    transition: "transform 0.2s, box-shadow 0.2s",
    cursor: "pointer",
  },
  result: {
    fontSize: "22px",
    marginTop: "20px",
    fontWeight: "bold",
  },
  prize: {
    fontSize: "24px",
    marginTop: "10px",
    color: "green",
  },
  score: {
    fontSize: "20px",
    marginTop: "20px",
    color: "#00695c",
  },
};

export default WheelOfDivision;
